import React from 'react';
import { motion } from 'framer-motion';
import './ThreeSimpleStep.css';

const ThreeSimpleStep = () => {
  return (
    <div className='process-container'>
      <div>
        <motion.button
          className='process-button'
          whileHover={{
            boxShadow:
              '0 0 5px black, 0 0 10px black, 0 0 15px white, 0 0 20px black',
            transition: { duration: 0.5 },
          }}
          whileTap={{
            scale: 0.9,
            transition: { duration: 0.2 },
          }}
        >
          Process
        </motion.button>
      </div>
      <div>
        <h1 className='framer-text'>
          Our Streamlined 4-Step Process to <br/>
          <span className='italic'>Amplify</span> Your Brand Organically.
        </h1>
      </div>

      <div className='framer-nqkn6i'>
        <p>
        From Web SEO optimization to social media management, to full content management,<br/>
         and even virtual challenge launch, we’ve got you covered on every organic front.
        </p>
      </div>
    </div>
  );
};

export default ThreeSimpleStep;
